export default __webpack_public_path__ + "static/media/nextvsReact.2558e449.md";